import React from 'react';
import { Card } from 'react-bootstrap';
import GenericFormCard from '../moduleCommonFormik/GenericFormCard.component';
import { USERNAME_UPDATE_FIELDS } from '../../features/modules/EstateManagement/DSCRegistration/DscRegistration.const';

const EmudhraUsernameUpdate = () => {
    return (
        <>
            <Card className='card_border'>
                <Card.Body>
                    {USERNAME_UPDATE_FIELDS.map(field => (
                        <GenericFormCard {...field} />
                    ))}
                </Card.Body>
            </Card>
        </>
    );
};

export default EmudhraUsernameUpdate;
